// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".RegularTelephone-module-control-2-OUl{display:flex;flex-basis:auto;gap:16px}[dir=rtl] .RegularTelephone-module-control-2-OUl{flex-direction:row-reverse;justify-content:flex-end}.RegularTelephone-module-code-3jxOw{padding-block:10px 0;min-width:115px}.RegularTelephone-module-phoneSelectBlock-3FIGc{display:flex}.RegularTelephone-module-telephoneFullWidth-3hift{width:100%}.RegularTelephone-module-phoneContainer-rX8dd{width:100%}.RegularTelephone-module-prefix-ybd1Z{margin-inline-end:8px;top:24px;height:20px;position:relative}.RegularTelephone-module-info-cIJwH{margin-block-start:8px}", ""]);
// Exports
exports.locals = {
	"control": "RegularTelephone-module-control-2-OUl",
	"code": "RegularTelephone-module-code-3jxOw",
	"phoneSelectBlock": "RegularTelephone-module-phoneSelectBlock-3FIGc",
	"telephoneFullWidth": "RegularTelephone-module-telephoneFullWidth-3hift",
	"phoneContainer": "RegularTelephone-module-phoneContainer-rX8dd",
	"prefix": "RegularTelephone-module-prefix-ybd1Z",
	"info": "RegularTelephone-module-info-cIJwH"
};
module.exports = exports;
